var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('pop-dialog', _vm._g(_vm._b({
    attrs: {
      "height": "auto",
      "width": _vm.isMobile ? '90vw' : '700px'
    }
  }, 'pop-dialog', _vm.$attrs, false), _vm.$listeners), [_c('div', {
    staticClass: "pop-main"
  }, [_c('div', {
    staticClass: "pop-title"
  }, [_vm._v(_vm._s(_vm.$lang("Task")))]), _c('div', {
    staticClass: "taskbox"
  }, [_c('div', {
    staticClass: "form"
  }, [_c('div', {
    staticClass: "form-item"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("抽奖次序")]), _c('div', {
    staticClass: "input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.modifyData.draw_index,
      expression: "modifyData.draw_index"
    }],
    attrs: {
      "placeholder": "抽奖次序从0开始"
    },
    domProps: {
      "value": _vm.modifyData.draw_index
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.modifyData, "draw_index", $event.target.value);
      }
    }
  })])]), _vm._l(_vm.modifyData.items, function (item, index) {
    return _vm.modifyData.items ? _c('div', {
      staticClass: "form-item"
    }, [_c('div', {
      staticClass: "label"
    }, [_vm._v("奖项" + _vm._s(index + 1))]), _c('div', {
      staticClass: "input"
    }, [_c('div', {
      staticClass: "custom-select"
    }, [_c('div', {
      staticClass: "selected-item",
      on: {
        "click": function ($event) {
          _vm.showOptions = !_vm.showOptions, _vm.select_index = index;
        }
      }
    }, [!item.id ? [_c('span', {
      staticClass: "option-text"
    }, [_vm._v("请选择一个礼品")])] : item.id && item?.gift_extra && item?.gift_extra?.gift_thumb ? [_c('img', {
      staticClass: "option-image",
      attrs: {
        "src": item.gift_extra.gift_thumb,
        "alt": "Selected Image"
      }
    }), _c('span', {
      staticClass: "option-text"
    }, [_vm._v("星星：" + _vm._s(item.gift_extra.gift_stars) + "， " + _vm._s(item.gift_extra.gift_type == 0 ? '电报原生' : "" + item.gift_extra.gift_type == 1 ? '电报NFT' : '其他') + "， 备注：" + _vm._s(item.gift_extra.remarks))])] : _vm._e()], 2), _vm.showOptions && _vm.select_index == index ? _c('div', {
      staticClass: "options-container"
    }, _vm._l(_vm.item_list, function (it, idx) {
      return _c('div', {
        staticClass: "option"
      }, [_c('img', {
        staticClass: "option-image",
        attrs: {
          "src": it.gift_extra.gift_thumb
        }
      }), _c('span', {
        staticClass: "option-text",
        on: {
          "click": function ($event) {
            item.id = it.id;
            item.gift_extra = it.gift_extra;
            _vm.showOptions = false;
            _vm.select_index = '';
          }
        }
      }, [_vm._v("星星：" + _vm._s(it.gift_extra.gift_stars) + "， " + _vm._s(it.gift_extra.gift_type == 0 ? '电报原生' : "" + it.gift_extra.gift_type == 1 ? '电报NFT' : '其他') + "， 备注：" + _vm._s(it.gift_extra.remarks))])]);
    }), 0) : _vm._e()]), _c('div', {
      staticClass: "delbtn",
      on: {
        "click": function ($event) {
          _vm.modifyData.items.splice(index, 1);
          _vm.showOptions = false;
        }
      }
    }, [_vm._v("删除")])])]) : _vm._e();
  }), _c('div', {
    staticClass: "form-item"
  }, [_c('div', {
    staticClass: "label"
  }), _c('div', {
    staticClass: "input",
    on: {
      "click": _vm.addItem
    }
  }, [_vm._v(" 增加奖项 ")])])], 2)]), _c('div', {
    staticClass: "btn",
    style: {
      background: _vm.themeMainColor(_vm.theme).main
    },
    on: {
      "click": _vm.onConfirm
    }
  }, [_vm._v(_vm._s(_vm.$lang("Submit")))])])]);
};
var staticRenderFns = [];
export { render, staticRenderFns };